import * as constants from "./constants";
import abbr from "../../../config/abbr";
import {
  apiGetAllNoTypeCourseList,
  apiGetSomeTypeCourseList,
  apiGetAllTypeCourseList,
  apiGetFameShare,
} from "../../../config/index";

export const changeTab1 = (id) => ({
  type: constants.CHANGE_TAB_1,
  id,
});

export const changeTab2 = (id) => ({
  type: constants.CHANGE_TAB_2,
  id,
});

export const changeTab3 = (id) => ({
  type: constants.CHANGE_TAB_3,
  id,
});
export const changeTab4 = (id) => ({
  type: constants.CHANGE_TAB_4,
  id,
});

export const changeTab2Arr = () => ({
  type: constants.CHANGE_TAB_2_ARR,
});

export const changeTab3Arr = (arr) => ({
  type: constants.CHANGE_TAB_3_ARR,
  arr,
});
export const changeTab4Arr = (arr) => ({
  type: constants.CHANGE_TAB_4_ARR,
  arr,
});

export const changeTab2ArrTell = () => ({
  type: constants.CHANGE_TAB_2_ARR_TELL,
});

export const setLoader = (value) => ({
  type: constants.SET_LOADER,
  value,
});

export const setPage = (page) => ({
  type: constants.SET_PAGE,
  page,
});

export const setTotal = (total) => ({
  type: constants.SET_TOTAL,
  total,
});

const changeList = (list) => ({
  type: constants.CHANGE_LIST,
  list,
});

export const getListByTab1 = (ppage, ppagesize, pexamId, sorttype) => {

  let page = parseInt(ppage);
  let pagesize = parseInt(ppagesize);
  let examPid = parseInt(pexamId);
  if(sorttype!=0){
    sorttype=1;
  }
  let sortType = parseInt(sorttype);
  let formData = {
    page,
    pagesize,
    examPid,
    sortType
  };
  return (dispatch) => {
    apiGetAllNoTypeCourseList(formData)
      .then((response) => {
        if (response.code === abbr.okId) {
          dispatch(changeList(response.data.list));

          dispatch(setTotal(response.data.total === 0? 1: response.data.total));
          } else {
          dispatch(changeList([]));
        }
        dispatch(setLoader(false));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};    

export const getListByTell = (ppage, ppagesize, pType, sortType) => {

  let pagesize = parseInt(ppagesize);
  if(pType){
    var  type = parseInt(pType);
  }else{
    var type =1;
  }
  let page = parseInt(ppage);
  let formData = {
    page,
    pagesize,
    type,
    sortType
  };
  return (dispatch) => {
    apiGetFameShare(formData)
      .then((response) => {
        if (response.code === abbr.okId) {
          dispatch(changeList(response.data));
          dispatch(setTotal(response.total));
        } else {
          dispatch(changeList([]));
        }
        dispatch(setLoader(false));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const changeListSomeType = (ppage, ppagesize, pexamId, pType, sortType,pexamPid) => {
  let page = parseInt(ppage);
  let pagesize = parseInt(ppagesize);

  if(pType){
    var  type = parseInt(pType);
  }else{
    var type ='';
  }
  let examPid ='';
  if(pexamPid){
    examPid = parseInt(pexamPid);
  }
  let examId ='';
  if(pexamId){
     examId = parseInt(pexamId);
  }
  if(sortType!=0){
    sortType=1;
  }
  let formData = {
    page,
    pagesize,
    examId,
    examPid,
    type,
    sortType
  };
  return (dispatch) => {
    apiGetSomeTypeCourseList(formData)
      .then((response) => {
        if (response.code === abbr.okId) {
          dispatch(changeList(response.data.list));
          dispatch(
            setTotal(
              response.data.total === 0
                ? 1
                : response.data.total
            )
          );
        } else {
          dispatch(changeList([]));
        }
        dispatch(setLoader(false));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const changeListOtherAll = (ppage, ppagesize, pexamId, pType, sortType) => {
  let page = parseInt(ppage);
  let pagesize = parseInt(ppagesize);
  let examPid = parseInt(pexamId);
  let type = parseInt(pType);
  if(sortType!=0){
    sortType=1;
  }
  let formData = {
    page,
    pagesize,
    examPid,
    type,
    sortType
  };
  return (dispatch) => {
    apiGetAllTypeCourseList(formData)
      .then((response) => {
        if (response.code === abbr.okId) {
          dispatch(changeList(response.data.list));
          dispatch(
            setTotal(
              response.data.total === 0
                ? 1
                : response.data.total
            )
          );
        } else {
          dispatch(changeList([]));
        }
        dispatch(setLoader(false));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};
